import { SchemaFieldType, Value } from '../../schemas/entity';

// export type FieldType = 'boolean' | 'number' | 'string' | 'object' | 'prompt' | 'picklist' | 'reference' | 'date_time';

export const getDefaultValueForType = (fieldType: SchemaFieldType): Value => {
  switch (fieldType) {
    case SchemaFieldType.BOOLEAN:
      return false;
    case SchemaFieldType.NUMBER:
      return 0;
    case SchemaFieldType.DATE_TIME:
      return { timeZone: 'UTC', date: '', time: '' };
    case SchemaFieldType.PROMPT:
      return { content: '<speak></speak>', kind: 'SSML' };
    case SchemaFieldType.OBJECT:
      return {};
    case SchemaFieldType.YAML:
      return '';
    case SchemaFieldType.PICK_LIST:
      return [];
    case SchemaFieldType.REFERENCE:
      return '';
    case SchemaFieldType.CONNECT_RESOURCE:
      return null;
    case SchemaFieldType.STRING:
    default:
      return '';
  }
};

// export const getFieldType = (schemaField: Field): FieldType => {
//   return schemaField?.definition?.type as FieldType || 'string';
// };
